import { Document } from '@contentful/rich-text-types'
import { Box, Grid, Typography } from '@mui/material'
import { StaticImageData } from 'next/image'

import { convertToComponent } from '@ecm/data/Contentful'
import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'
import ContentfulImage, { ImageType } from '@ecm/ui/element/ContentfulImage'

type CaseStudyCardProps = {
  organizationName: string
  description: Document
  index: number
  industry: string[]
  logoImg: StaticImageData
  slug: string
}

const CaseStudyCard = ({
  organizationName,
  description,
  index,
  industry,
  logoImg,
  slug,
}: CaseStudyCardProps) => (
  <Anchor
    href={`/case-studies/${slug}`}
    display="flex"
    flexDirection="column"
    bgcolor={Color.white.normal}
    boxShadow="0px 10px 20px rgba(23, 41, 115, 0.06)"
    borderRadius="8px"
    sx={{
      ':hover': { boxShadow: '0px 10px 25px 5px rgba(75, 79, 99, 0.1)' },
    }}
  >
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      height="184px"
      borderBottom={`1px solid ${Color.smoke.normal}`}
    >
      <ContentfulImage
        imageType={ImageType.NonResponsive}
        src={logoImg}
        alt={`${organizationName} logo`}
        layout="fixed"
        priority={index < 3}
      />
    </Grid>

    <Grid
      container
      direction="column"
      justifyContent="space-between"
      p="24px 24px 16px"
      flexGrow="1"
    >
      <Typography variant="p1" fontWeight={700}>
        {organizationName}
      </Typography>
      {convertToComponent(description, 'p3')}

      <Box>
        <Typography variant="p3" fontWeight={700}>
          Industry:
        </Typography>

        <Grid container>
          {industry.map(industry => (
            <Typography
              display="block"
              key={industry}
              variant="overline"
              fontSize="11px"
              color={Color.saint.normal}
              p="6px 10px"
              mb="8px"
              borderRadius="4px"
              bgcolor={Color.smoke.lighter}
              sx={{ '&:not(:last-child)': { mr: '8px' } }}
            >
              {industry}
            </Typography>
          ))}
        </Grid>
      </Box>
    </Grid>
  </Anchor>
)

export default CaseStudyCard
